import NavBar from "../webcomponents/NavBar";
import "../css/WebPage.css";
import WebFooter from "../webcomponents/WebFooter";

const HomePage = () =>{

    const handleLinkClick = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    }

    return(
        <div className="home">
            <NavBar />
            {/*HERO*/}
            <div 
                className="home-hero" 
                style={{height:"90dvh", position:"relative", 
                    display:"flex", flexDirection:"column", justifyContent:"flex-end", alignItems:"center"}}
            >

                <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", 
                    margin:"50px"}}>
                    <img src="/assets/homepage/slimeville_logo.png" style={{width:"50%"}}/>
                    <div 
                        style={{margin:"20px", textAlign:"center", fontWeight:"500", color:"white"}}
                    >
                        A Quirky town where kids and adults <br/> come to let their creativity fluid.
                    </div>
                </div>
            </div>

            {/*BOOKING SECTION*/}
            <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", width:"100%", justifyContent:"center", minHeight:"50dvh"}}>
                {/*BOOKING BUTTONS*/}
                <div style={{
                    flex: "1 1 300px",
                    maxWidth: "500px",
                    minWidth:"200px",
                    padding: "20px",
                    display:"flex",
                    justifyContent:"center"
                }}>
                    <div 
                        style={{                    
                            display: "grid",
                            width: "fit-content",
                            gridTemplateColumns: "repeat(2, auto)",
                            justifyItems: "center",   // <--- important!
                            alignItems:"center",
                            margin: "0 auto"
                        }}
                    >
                        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                            <img src="/assets/homepage/slime_mascot1.png" style={{width:"140px"}}/>
                        </div>
                        <div className="pink-btn" onClick={()=>handleLinkClick("https://lin.ee/Uoj6YqH")}>
                            BOOK <br/> SESSION
                        </div>
                        <div className="pink-btn" onClick={()=>handleLinkClick("https://www.facebook.com/profile.php?id=61556098372364")}>
                            VISIT <br/> OUR <br/> PAGE
                        </div>
                        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                            <img src="/assets/homepage/slime_mascot3.png" style={{width:"160px"}}/>
                        </div>
                    </div>
                </div>


                {/*UPCOMING*/}
                <div 
                    style={{
                        flex: "1.5 1.5 300px",
                        aspectRatio: "1 / 1.5", // makes it a perfect square
                        margin: "20px",
                        backgroundColor: "#bbc4ff",
                        borderRadius: "30px",
                        padding: "25px",
                        color: "white",
                        width:"80%",
                        maxWidth: "600px",
                        maxHeight:"60dvh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems:"center",
                        overflow: "hidden"
                }}
                >
                    <div style={{width:"100%"}}>
                        <div style={{ fontSize:"1.2em", fontWeight:"400"}}>Upcoming</div>
                        <div style={{ fontSize:"2.5em", fontWeight:"600", marginBottom:"20px", lineHeight:"1em" }}>
                        CUPCAKES SLIME
                        </div>
                    </div>

                    <img 
                        src="/assets/homepage/slime_cupcake.png"
                        style={{
                        width:"100%",
                        height:"100%",  
                        objectFit:"cover",
                        borderRadius:"20px",
                        }}
                    />
                </div>

            </div>

            {/*CONTACT SECTION*/}

            <div style={{fontWeight:"800", color:"#e6427a", fontSize:"38px", margin:"40px 0px 0px 0px"}}>OUR STORE</div>

            <div className="contact-section" style={{position:"relative"}}>
                <img src="/assets/homepage/slime_burb.png" style={{position:"absolute", width:"120%", zIndex:"-1", top:"50%", left:"50%", transform:"translate(-50%,-50%)"}}/>
                <div style={{display:"flex", flex:"3", flexDirection:"column", alignItems:"center"}}>
                    <div className="branch-group">
                        <div className="home-shop">
                            <img src="/assets/homepage/slimeville_shop_49.png" />
                            <div style={{fontSize:"21px", fontFamily:"Quicksand", fontWeight:"600", marginBottom:"10px"}}>Slimeville 49</div>
                            <div style={{fontSize:"16px", fontFamily:"Quicksand", lineHeight:"20px", marginBottom:"10px"}}>Playscape <br/> Sukhumvit 49</div>
                            <div style={{fontSize:"16px", fontFamily:"Quicksand", lineHeight:"24px", marginBottom:"10px"}}>Everyday 10.00-20.00</div>
                        </div>
                        <div className="home-shop">
                            <img src="/assets/homepage/slimeville_shop_ctw.png" />
                            <div style={{fontSize:"21px", fontFamily:"Quicksand", fontWeight:"600", marginBottom:"10px"}}>Slimeville Studio</div>
                            <div style={{fontSize:"16px", fontFamily:"Quicksand", lineHeight:"20px", marginBottom:"10px"}}>Central World, 6th Floor <br/> Little Wonder Zone</div>
                            <div style={{fontSize:"16px", fontFamily:"Quicksand", lineHeight:"24px", marginBottom:"10px"}}>Everyday 10.00-18.00</div>
                        </div>
                    </div>

                </div>

                <div style={{flex:"1", margin:"30px", padding:"40px 30px", backgroundColor:"#fc70a6", width:"75%", maxWidth:"850px", borderRadius:"50px", position:"relative"}}>
                    <div style={{textAlign:"center", fontWeight:"600", fontSize:"31px", color:"white", marginBottom:"20px"}}>CONTACT US</div>
                    <div className="contact-group">
                        <div className="contact-card" onClick={()=>handleLinkClick("https://lin.ee/Uoj6YqH")}>
                            <img src="/assets/homepage/icon_line.png"/>
                            <div style={{fontFamily:"Quicksand", fontWeight:"600"}}>@slimeville.th</div>
                        </div>
                        <div className="contact-card" onClick={()=>handleLinkClick("https://www.instagram.com/slimeville.th")}>
                            <img src="/assets/homepage/icon_ig.png"/>
                            <div style={{fontFamily:"Quicksand", fontWeight:"600"}}>slimeville.th</div>
                        </div>
                        <div className="contact-card">
                            <img src="/assets/homepage/icon_phone.png"/>
                            <div style={{fontFamily:"Quicksand", fontWeight:"600"}}>082-123-2452</div>
                        </div>
                        <div className="contact-card">
                            <img src="/assets/homepage/icon_fb.png" onClick={()=>handleLinkClick("https://www.facebook.com/profile.php?id=61556098372364")}/>
                            <div style={{fontFamily:"Quicksand", fontWeight:"600"}}>slimeville.th</div>
                        </div>
                    </div>
                </div>
            </div>

            <WebFooter />
        </div>
    );
};

export default HomePage;